// export const environment = {
//   production: false,
//   endpoints: {
//     apiUrl: 'https://editortest.txdocs.com/api',
//     websocketUrl: 'wss://editortest.txdocs.com/'
//   },
//   name: 'TXdocs Editor'
// }

export const environment = {
  appInsights: {
    instrumentationKey: '23265c8f-df25-4788-991a-aa175550edd5',
  },
  production: true,
  endpoints: {
    baseUrl: 'https://editortest.txdocs.com',
    apiUrl: 'https://editortest.txdocs.com/api',
    websocketUrl: 'wss://editortest.txdocs.com/api/TXWebSocket',
  },
  name: 'TXdocs Editor',
};
